var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5733 4.3042H7.42629C5.77486 4.3042 4.43457 5.60507 4.43457 7.20793V25.7918C4.43457 27.3946 5.77486 28.6955 7.42629 28.6955H26.5733C28.2247 28.6955 29.565 27.3946 29.565 25.7918V7.20793C29.565 5.60507 28.2247 4.3042 26.5733 4.3042ZM12.213 13.5961V24.6303H8.62298V13.5961H12.213ZM8.62298 10.3846C8.62298 9.57156 9.34099 8.95016 10.418 8.95016C11.495 8.95016 12.1712 9.57156 12.213 10.3846C12.213 11.1976 11.5429 11.8539 10.418 11.8539C9.34099 11.8539 8.62298 11.1976 8.62298 10.3846ZM25.3766 24.6303H21.7865C21.7865 24.6303 21.7865 19.2526 21.7865 18.8228C21.7865 17.6613 21.1882 16.4999 19.6923 16.4766H19.6445C18.1965 16.4766 17.5981 17.673 17.5981 18.8228C17.5981 19.3513 17.5981 24.6303 17.5981 24.6303H14.0081V13.5961H17.5981V15.0828C17.5981 15.0828 18.7529 13.5961 21.0745 13.5961C23.4499 13.5961 25.3766 15.1816 25.3766 18.3931V24.6303Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLinkedin);
export default __webpack_public_path__ + "static/media/ic_linkedin.2e52d345ceb61b93c9e71705eef8cb39.svg";
export { ForwardRef as ReactComponent };